import { render } from "./CommentsTab.vue?vue&type=template&id=35eefb84"
import script from "./CommentsTab.vue?vue&type=script&lang=js"
export * from "./CommentsTab.vue?vue&type=script&lang=js"

import "./CommentsTab.vue?vue&type=style&index=0&id=35eefb84&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "35eefb84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35eefb84', script)) {
    api.reload('35eefb84', script)
  }
  
  module.hot.accept("./CommentsTab.vue?vue&type=template&id=35eefb84", () => {
    api.rerender('35eefb84', render)
  })

}

script.__file = "src/components/no-message/tabs/CommentsTab.vue"

export default script